import React from 'react';
import ReactPlayer from 'react-player/vimeo';
import './vimeo.css';

const Vimeo = ({ vimeoId, onClick, ...otherProps }) => (
  <div className="react-player-wrapper">
    <ReactPlayer
      className="react-player"
      url={`https://vimeo.com/${vimeoId}`}
      width="100%"
      height="100%"
      onPlay={onClick}
      controls
      {...otherProps}
    />
  </div>
);

export default Vimeo;
